import "./BridalSuite.module.css";
import Header from "@/reusable_sections/Header";
import BookingEssentials from "./sections/BookingEssentials";
import BridalFaq from "./sections/BridalFaq";
import Footer from "@/reusable_sections/Footer";
export default function BridalSuitePage() {
  return <div>
      <Header />
      <BookingEssentials />
      <BridalFaq />
      <Footer />
    </div>;
}